/** No 0/O, 1/l/I: the person setting it has to read it out to somebody. */
const ALPHABET = 'abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ23456789';

/**
 * A password generated in the browser and sent, rather than invented by the server and returned: a secret
 * the server invents has been through a response body and a log before anybody decides whether it was
 * needed (R0002 D-11).
 */
export const generatePassword = (length = 16): string => {
  const bytes = new Uint32Array(length);

  crypto.getRandomValues(bytes);

  return Array.from(bytes, (value) => ALPHABET[value % ALPHABET.length]).join('');
};
